import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.delete(payload).then(res => {
       
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        console.log(err);
        
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionDuplica = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.duplica(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionCola = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.cola(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.pesquisa(payload).then(res => {
        dispatch('ActionSetPesquisa',res)
    }).catch(err => {
        dispatch('ActionSetPesquisa',res)
    })
}
export const ActionEventoCadastro = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.eventocadastro(payload).then(res => {
        dispatch('ActionSetListaEvento',res)
    }).catch(err => {
        dispatch('ActionSetListaEvento',err)
    })
}
export const ActionEventoDeletar = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.eventodeleta(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEventoUpdate = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.eventoupdate(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionCodigo = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.codigo(payload).then(res => {
        dispatch('ActionSetCodigo',res)
    }).catch(err => {
        dispatch('ActionSetCodigo',err)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetPesquisa = ({commit},payload) =>{
    commit(types.SET_PESQUISA,payload)
}
export const ActionSetEvento = ({commit},payload) =>{
    commit(types.SET_EVENTO,payload)
}
export const ActionSetListaEvento = ({commit},payload) =>{
    commit(types.SET_LISTAEVENTO,payload)
}
export const ActionSetCodigo = ({commit},payload) =>{
    commit(types.SET_CODIGO,payload)
}